import BaseComponent from '/webresources-sources/js/components/base-component';
import { urlQuery } from '/webresources-sources/js/util/url';
import { percentageInViewport } from '/webresources-sources/js/util/percentage-in-viewport';
import { defineComponent } from '/webresources-sources/js/util/jquery';
import { asyncHTMLInjected } from '/webresources-sources/js/util/html';

const LOADING_TIMEOUT = 1200;

function debounce(callback, wait) {
    let timeout;
    return (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(function () {
            callback.apply(this, args);
        }, wait);
    };
}

// TODO: this is a modified copy of bayern-tourism-frontend/templates/components/pages-overview/pages-overview-component.js
export default class DsftOverviewComponent extends BaseComponent {
    properties() {
        return {
            selectedCategories: [],
            filteredCategories: {},
            url: '',
            contentPath: '',
            searchString: '',
            currentPage: 0,
            previousPageIndex: -1,
            totalItems: 0,
            loading: false,
        };
    }

    connected() {
        this.calculateCSSProperties();
        this.updateUrl();
        const filterSection = this.element.querySelector('.filter-section');
        const overviewSection = this.element.querySelector('.overview-section');

        if (!filterSection || !overviewSection) return;

        let filterSectionVisible = 0;
        let overviewSectionVisible = 0;

        const observer = new IntersectionObserver(
            (entries, observer) => {
                entries.forEach((entry) => {
                    filterSectionVisible = percentageInViewport(filterSection);
                    overviewSectionVisible = percentageInViewport(overviewSection);

                    if (filterSectionVisible <= 0 && overviewSectionVisible <= 0) {
                        // somewhere at the top or at the bottom
                        this.element.classList.remove('is-filtering');
                        this.element.classList.remove('is-overviewing');
                    } else if (filterSectionVisible > 0 && overviewSectionVisible <= 60) {
                        // filtering
                        this.element.classList.add('is-filtering');
                        this.element.classList.remove('is-overviewing');
                    } else if (filterSectionVisible < 50 && overviewSectionVisible >= 60) {
                        // overviewing
                        this.element.classList.remove('is-filtering');
                        this.element.classList.add('is-overviewing');
                    } else {
                        // somewhere at the top or at the bottom
                        this.element.classList.remove('is-filtering');
                        this.element.classList.remove('is-overviewing');
                    }
                });
            },
            {
                root: document,
                rootMargin: '0px',
                threshold: [
                    0, 0.05, 0.1, 0.15, 0.2, 0.25, 0.3, 0.35, 0.4, 0.45, 0.5, 0.55, 0.6, 0.65, 0.7, 0.75, 0.8, 0.85,
                    0.9, 0.95, 1,
                ],
            },
        );

        observer.observe(filterSection);
        observer.observe(overviewSection);

        document.addEventListener(
            'scroll',
            (e) => {
                const filterActionsElement = this.element.querySelector('#filter-actions');
                const isSticky = filterActionsElement.getBoundingClientRect().top <= 0;
                filterActionsElement.classList.toggle('is-sticky', isSticky);
                filterActionsElement.classList.toggle('bg-dark', isSticky);
            },
            { passive: true },
        );

        /** @type PageCount */
        this.pageCount = this.element.querySelector('page-count');
    }

    afterUpdate() {
        this.updateUrl();

        const filterCountElement = this.element.querySelector('[data-filter-count]');
        if (filterCountElement) {
            filterCountElement.innerHTML = `(${this.selectedCategories.length})`;
        }

        const categoryFilterCountElements = this.element.querySelectorAll('[data-category-filter-count]');
        for (const categoryFilterCountElement of categoryFilterCountElements) {
            const category = categoryFilterCountElement.getAttribute('data-category-filter-count');
            if (this.filteredCategories[category] && this.filteredCategories[category].length > 0) {
                categoryFilterCountElement.innerHTML = `(${this.filteredCategories[category].length})`;
            } else {
                categoryFilterCountElement.innerHTML = ``;
            }
        }

        // total count
        const resultsCount = this.element.querySelectorAll('[data-results-count]');
        for (const resultsCountElement of resultsCount) {
            resultsCountElement.innerHTML = this.loading
                ? '<div class="dsft-looading-spinner"><div></div><div></div><div></div></div>'
                : this.totalItems;
        }

        if (this.pageCount) {
            this.pageCount.totalItems = this.totalItems;
            this.pageCount.currentPage = this.currentPage;
            this.pageCount.previousPageIndex = this.previousPageIndex;
        }
    }

    watch() {
        return {
            selectedCategories: (selectedCategories) => {
                const clearFilterButton = this.element.querySelector('[data-clear-filter]');

                if (!clearFilterButton) return;

                if (selectedCategories && selectedCategories.length > 0) {
                    clearFilterButton.classList.remove('d-none');
                } else {
                    clearFilterButton.classList.add('d-none');
                }
            },
        };
    }

    events() {
        return {
            this: {
                'init-dsft-categories': (e) => {
                    this.selectedCategories = e.detail.selectedCategories;
                    this.filteredCategories = e.detail.filteredCategories;
                },
                'select-dsft-categories': (e) => {
                    this.selectedCategories = e.detail.selectedCategories;
                    this.filteredCategories = e.detail.filteredCategories;
                    this.currentPage = 0;

                    this.dispatch('loading-start');
                    this.loading = true;
                    this.fetchPages().then((html) => {
                        this.dispatch('loading-end');
                        const pageCount = $(html).find('.page-count');
                        this.totalItems = pageCount?.attr('total-items');
                        const container = this.element.querySelector('.pages');
                        $(container).html($(html).find('.page-count,.previous-page,.page,.next-page'));
                        asyncHTMLInjected();
                        this.registerEvents();
                        setTimeout(() => (this.loading = false), LOADING_TIMEOUT);
                    });
                },
            },
            'input[type="search"]': {
                keyup: debounce((e) => {
                    const input = e.target;
                    this.searchString = input.value;

                    this.dispatch('loading-start');
                    this.loading = true;
                    this.fetchPages().then((html) => {
                        this.dispatch('loading-end');
                        const pageCount = $(html).find('.page-count');
                        this.totalItems = pageCount?.attr('total-items');
                        const container = this.element.querySelector('.pages');
                        $(container).html($(html).find('.page-count,.previous-page,.page,.next-page'));
                        asyncHTMLInjected();
                        this.registerEvents();
                        setTimeout(() => (this.loading = false), LOADING_TIMEOUT);
                    });
                }, 500),
            },
            '[data-submit-search]': {
                click: (e) => {
                    e.preventDefault();
                    const input = this.element.querySelector('input[type="search"]');
                    this.searchString = input.value;

                    this.dispatch('loading-start');
                    this.loading = true;
                    this.fetchPages().then((html) => {
                        this.dispatch('loading-end');
                        const pageCount = $(html).find('.page-count');
                        this.totalItems = pageCount?.attr('total-items');
                        const container = this.element.querySelector('.pages');
                        $(container).html($(html).find('.page-count,.previous-page,.page,.next-page'));
                        asyncHTMLInjected();
                        this.registerEvents();
                        setTimeout(() => (this.loading = false), LOADING_TIMEOUT);
                    });
                },
            },
            '[data-clear-filter]': {
                click: (e) => {
                    const filterElement = this.element.querySelector('[data-component="dsft-overview-filter"]');
                    filterElement._component.clearFilters();
                },
            },
            '[load-previous-page]': {
                click: (e) => {
                    e.preventDefault();
                    this.currentPage = parseInt(e.target.getAttribute('load-previous-page'));

                    this.fetchPages(this.currentPage).then((html) => {
                        const container = this.element.querySelector('.previous-page');
                        $(container).replaceWith($(html).find('.previous-page,.page'));
                        asyncHTMLInjected();
                        this.registerEvents();
                        $('.teaser-accessibility-icon').tooltip();
                    });
                },
            },
            '[load-next-page]': {
                click: (e) => {
                    e.preventDefault();
                    this.currentPage = parseInt(e.target.getAttribute('load-next-page'));

                    this.fetchPages(this.currentPage).then((html) => {
                        const container = this.element.querySelector('.next-page');
                        $(container).replaceWith($(html).find('.page,.next-page'));
                        asyncHTMLInjected();
                        this.registerEvents();
                        $('.teaser-accessibility-icon').tooltip();
                    });
                },
            },
            '[data-page]': {
                click: (e) => {
                    const pageContainer = e.target.closest('[data-page]');
                    if (e.target.nodeName === 'A' && pageContainer) {
                        this.currentPage = parseInt(pageContainer.dataset.page);
                    }
                },
            },
        };
    }

    get urlParameters() {
        const filteredCategories = {};
        for (const [key, value] of Object.entries(this.filteredCategories)) {
            filteredCategories[key] = value?.length > 0 ? value : undefined;
        }
        const parameters = {
            ...filteredCategories,
            search: this.searchString || undefined,
            currentPage: this.currentPage > 0 ? this.currentPage : undefined,
        };
        // scope parameters for url (because other "filtered" components could use the same filter names)
        const scopedParameters = {};
        for (const parameter of Object.keys(parameters)) {
            // bf für barrier-free
            scopedParameters[`bf-${parameter}`] = parameters[parameter];
        }
        return scopedParameters;
    }

    fetchPages() {
        return fetch(`${this.contentPath}?${urlQuery(this.urlParameters)}`).then((result) => result.text());
    }

    updateUrl() {
        const parameters = this.urlParameters;
        const query = urlQuery(parameters, true);
        history.replaceState(parameters, '', query ? `?${query}` : location.pathname);
    }

    calculateCSSProperties() {
        const filterActionsElement = this.element.querySelector('#filter-actions');
        const filterActionsHeight = filterActionsElement.offsetHeight;

        if (filterActionsHeight) {
            this.element.style.setProperty('--scroll-margin-top', filterActionsHeight + 'px');
        }
    }
}

defineComponent('dsft-overview-component', DsftOverviewComponent);
